import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to develop a mobile app in Chicago?",
    answer: ` <p>The cost of developing a mobile app in Chicago primarily depends on the number of platforms you choose and the advanced features and functionalities you want to incorporate. For instance, native android app development in Chicago costs around $40,000. Similarly, native iOS app development in Chicago cost the same amount, but if you go for cross-platform app development, you can get both iOS and Android apps for the price of one. However you can use our <Link to="/app-cost-calculator">cost calculator</Link> to get a rough estimation for your business application!</p>
        <p>For accurate estimates, connect with our expert Chicago app developers or calculate the cost using our app development <Link to="/app-cost-calculator">cost calculator.</Link></p>`,
  },
  {
    question: "How much time does it take to develop an app?",
    answer: ` <p>The average time to develop a feature-rich mobile app with all the design aesthetics and functionalities is around 6 – 8 months. However, you don’t have to wait another 6 – 8 months if you choose cross-platform app development. With this approach, you can get both iOS and Android versions of your app within 6 – 8 months, as our Chicago app developers will use the same codebase to build both versions of your app.</p>`,
  },
  {
    question:
      "How is TekRevol's mobile app development process different from others?",
    answer: `<p>At TekRevol, we do not rush to sign the contract without building a relationship where both parties have unshakable trust in each other. We understand that building an app requires a substantial capital investment and entrepreneurs like you save their hard-earned money for years to finally start their app entrepreneurial journey. Thus, we ensure complete transparency about our pricing, deadlines, and work ethics to create a bond where you don’t have to micromanage us and our Chicago app developers can unleash their creativity to give you the best possible results within the given time.</p>`,
  },
  {
    question: "Where are you located in Chicago?",
    answer: `<p>We are located at “222 W Merchandise Mart Plaza Floor 12, Suite 1212, Chicago, IL 60654”.</p>`,
  },
  {
    question:
      "How do I find the best mobile app developers in Chicago near me?",
    answer: `<p>You just need to do a Google search for mobile app developers in Chicago near me and you'll come up with a ton of results. After visiting each one's website to look through their products and portfolios, you can assess their expertise and schedule a consultation with their experts to discuss your project and find out more about their app development services.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
